import React, {useState} from 'react'
import Button from '../components/Button'
import CreateOrderScreen from '../screens/CreateOrderScreen';


const Header = ({orderTitle, orderSubtitle, showButton}) => {

  const [isSidePageOpen, setIsSidePageOpen] = useState(false);

  const handleOpenButtonClick = () => {
    setIsSidePageOpen(true);
  };

  const handleCloseButtonClick = () => {
    setIsSidePageOpen(false);
  };


  return (
    <section className='flex header-section'>
        <div className='flex flex-col'>
            <h1 className='welcome-text'>{orderTitle}</h1>
            <p className='welcome-subtitle'>{orderSubtitle}</p>
        </div>
        {showButton && (
        <div className=''>
          <div className='header-btn-section'>
            <Button onClick={handleOpenButtonClick}>Create an order</Button>
            <div className="overlay" onClick={handleCloseButtonClick} style={{ display: isSidePageOpen ? 'block' : 'none' }}></div>
            <CreateOrderScreen isOpen={isSidePageOpen} onClose={handleCloseButtonClick} />
          </div>
        </div>
      )}
      
        
    </section>
  )
}

export default Header